let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("70aiP"), load("71Mer")]).then(() => parcelRequire('4jXWJ'));